import React from 'react';
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { ChannelMetricsResponse } from '@troia-v3/types';

import { formatCompact } from './formatMetrics';

export const ReachChartCard: React.FC<{ data: ChannelMetricsResponse[] }> = ({ data }) => {
  const chart = data.map((d) => ({ label: d.date.slice(5), reach: d.reach ?? 0, full: d.date }));
  return (
    <div className="cdash-card" data-testid="cdash-reach-chart">
      <span className="cdash-mlabel">Alcance no período</span>
      <div className="cdash-chart">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={chart}>
            <defs>
              <linearGradient id="cdash-grad-reach" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#8b5cf6" stopOpacity={0.22} />
                <stop offset="100%" stopColor="#8b5cf6" stopOpacity={0} />
              </linearGradient>
            </defs>
            <XAxis dataKey="label" tick={{ fontSize: 10, fill: '#94a3b8' }} axisLine={false} tickLine={false} />
            <YAxis
              tickFormatter={(v) => formatCompact(Number(v))}
              tick={{ fontSize: 10, fill: '#94a3b8' }}
              axisLine={false}
              tickLine={false}
              width={46}
            />
            <Tooltip
              formatter={(v) => [formatCompact(Number(v)), 'Alcance']}
              labelFormatter={(_l, p) => {
                const point = Array.isArray(p) ? (p[0]?.payload as { full?: string } | undefined) : undefined;
                return point?.full ?? '';
              }}
              contentStyle={{ borderRadius: 10, border: '1px solid rgba(15,23,42,.08)', fontSize: 12 }}
            />
            <Area type="monotone" dataKey="reach" stroke="#7c3aed" strokeWidth={2} fill="url(#cdash-grad-reach)" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
